import { useEffect, useState } from 'react';
import styled from 'styled-components';
import api from '../../../../Component/axios_Interceptor/api';
import url from '../../../../Component/server';
import ExpandableNotice from '../../../../Component/UI/ExpandableNotice';

type Notice = { seq: number; title: string | null; content: string };

export default function LivePreviewNotices({ liveSeq }: { liveSeq: number }) {
  const [notices, setNotices] = useState<Notice[]>([]);
  useEffect(() => {
    setNotices([]);
    let active = true, version = 0;
    const load = async () => {
      const request = ++version;
      try {
        const { data } = await api.get(url.Communication_url.get_live_notice, { params: { seq: liveSeq, type: 'rn' } });
        if (active && request === version && Array.isArray(data)) {
          setNotices(data.filter(item => item?.type === 'rn' && typeof item.content === 'string' && item.content.trim()));
        }
      } catch { /* Retain the last confirmed notices while the connection recovers. */ }
    };
    const refresh = () => { if (!document.hidden) void load(); };
    void load();
    window.addEventListener('focus', refresh);
    const timer = window.setInterval(refresh, 15000);
    return () => { active = false; version++; window.clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, [liveSeq]);
  if (!notices.length) return null;
  return <Notices aria-label="라이브 공지사항">
    <h2>공지사항</h2>
    {notices.map(notice => <article key={notice.seq}>
      {notice.title && <h3>{notice.title}</h3>}
      <ExpandableNotice content={notice.content} collapsedLines={2} />
    </article>)}
  </Notices>;
}

const Notices = styled.section`
  flex-shrink: 0; min-width: 0; margin-top: var(--space-3); padding: var(--space-3);
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md);
  background: var(--color-bg-surface); color: var(--color-text-primary);
  font-size: var(--text-body); line-height: var(--leading-body);
  h2 { margin: 0 0 var(--space-2); font-size: var(--text-body); font-weight: 600; }
  h3 { margin: 0 0 var(--space-1); font-size: var(--text-caption); font-weight: 600; color: var(--color-text-secondary); }
  article + article { margin-top: var(--space-3); padding-top: var(--space-3); border-top: 1px solid var(--color-border-default); }
`;
